import { type z } from 'zod'

import { type schemas } from '~interface/zod-schema'

// Zod-inferred types
export type MassCommunication = z.infer<typeof schemas.MassCommunication>
export type MassCommunicationReceipt = z.infer<typeof schemas.MassCommunicationReceipt>
export type ContactOutboundComm = z.infer<typeof schemas.ContactOutboundComm>
export type SmsCapability = z.infer<typeof schemas.GetOrganizationSmsCapabilityViewResponseData>
export type EmailCapability = z.infer<typeof schemas.GetOrganizationEmailCapabilityViewResponseData>
export type CommunicationSourceEmails = z.infer<
  typeof schemas.GetOrganizationSourceEmailsViewResponseData
>
export type CommunicationSenderOption = NonNullable<CommunicationSourceEmails['senders']>[number]

export interface ReceiptSummary {
  total: number
  pending: number
  sent: number
  delivered: number
  failed: number
  bounced: number
  opted_out?: number
  opened?: number
  responded?: number
}

export type MassCommResponse = z.infer<typeof schemas.MassCommResponse>

export interface PreviewRecipient {
  contact_entry_id: string
  name: string
  phone?: string
  email?: string
}

// Channel enum matches backend CommunicationChannel IntegerChoices
export const ChannelEnum = {
  EMAIL: 0,
  SMS: 1,
} as const

// Status enum matches backend MassCommunicationStatus IntegerChoices
export const StatusEnum = {
  DRAFT: 0,
  SENDING: 1,
  SENT: 2,
  FAILED: 3,
  SCHEDULED: 4,
} as const

// Receipt status enum matches backend ReceiptStatus IntegerChoices
export const ReceiptStatusEnum = {
  PENDING: 0,
  SENT: 1,
  DELIVERED: 2,
  FAILED: 3,
  BOUNCED: 4,
  OPTED_OUT: 5,
  OPENED: 6,
} as const
